export { ComponentIcon } from './ComponentIcon';
